import { combineReducers } from '@reduxjs/toolkit';
import reducers from './features';

const appReducer = combineReducers(reducers)

export type RootState = ReturnType<typeof appReducer>

export default appReducer;